module.exports = __webpack_public_path__ + "static/img/shinhanbank-sign.ffe3d90.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/shinhanbank-sign.jpg
// module id = VgfY
// module chunks = 0